import { useEffect, useState } from 'react';
import { client } from '../api/client';
import { Endpoints } from '../api/endpoints';

export interface ShopContext {
  domain: string;
  currency: string;
  timezone: string;
  plan_tier: string;
  plan_limits: Record<string, unknown>;
  settings: Record<string, unknown>;
}

/**
 * Loads the current shop context. In an embedded Shopify app the session token
 * is provided by App Bridge and attached by the API client; here we exchange it
 * against POST /api/auth/session.
 */
export function useShop() {
  const [shop, setShop] = useState<ShopContext | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    client
      .post(Endpoints.auth.session, {})
      .then((res) => {
        if (mounted) setShop(res.data.shop);
      })
      .catch((e: Error) => {
        if (mounted) setError(e.message);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { shop, loading, error };
}
